<template>
  <main class="[ flow ] [ gap-b-3 pad-b-start-3 ]">
    <section class="[ flow ] [ gap-b-end-2 ]">
      <h2>Timer</h2>
      <p>Dauer für den Timer stellen.</p>
      <Sidebar
        side="right"
        gutter="none"
        targetWidth="8rem"
        contentMinWidth="50%"
      >
        <input
          id="timerDuration"
          name="timerDuration"
          type="number"
          :min="timerConfig.min"
          :max="timerConfig.max"
          :value="timerConfig.value"
          @input="handleTimerUpdate"
        />
        <label for="timerDuration">
          Minuten<span class="visually-hidden">Laufzeit für den Timer</span>
        </label>
      </Sidebar>
      <p class="color-state-bad text--1" v-show="timerError">
        Nur eine Zahl zwischen {{ timerConfig.min }} und
        {{ timerConfig.max }} eingeben.
      </p>
    </section>

    <section class="[ flow ] [ gap-b-end-2 ]">
      <h2>Buchstaben</h2>
      <p>
        Buchstaben wählen die gespielt werden sollen.
        <span class="weight-bold"> Gewählt {{ activeLetters.length }}</span>
      </p>
      <AutoGrid
        minItemSize="60px"
        gutter="var(--size-1)"
        @change="handleLetterUpdate"
      >
        <Letter
          v-for="letter in letters"
          :key="letter.value"
          :letter="letter"
        ></Letter>
      </AutoGrid>
    </section>

    <Button
      radius="true"
      :disabled="timerError || activeLetters.length === 0"
      @click="startGame"
    >
      Spiel starten
    </Button>
  </main>
</template>

<script>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { computed, ref } from "vue";
import Sidebar from "../components/composition/Sidebar.vue";
import AutoGrid from "../components/composition/AutoGrid.vue";
import Letter from "../components/block/Letter.vue";

export default {
  components: {
    Sidebar,
    AutoGrid,
    Letter,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const timerError = ref(false);

    const timerConfig = computed(() => {
      return store.getters.getTimer;
    });

    const letters = computed(() => {
      return store.getters.getLetters;
    });

    const activeLetters = computed(() => {
      return store.getters.getActiveLetters;
    });

    const handleTimerUpdate = (event) => {
      // Store the input value as number
      let valueNum = parseInt(event.target.value);
      // Check if NaN
      if (isNaN(valueNum)) {
        timerError.value = true;
      } else {
        timerError.value = false;
        // Set stored value to min or max if < || >
        if (valueNum < timerConfig.value.min) {
          valueNum = timerConfig.value.min;
        } else if (valueNum > timerConfig.value.max) {
          valueNum = timerConfig.value.max;
        }
        event.target.value = valueNum;
        // Update store
        store.dispatch("updateTimer", valueNum);
      }
    };

    const handleLetterUpdate = (event) => {
      // Create an object as for action payload
      const letter = {};
      letter.value = event.target.id;
      letter.active = event.target.checked;
      // Update store
      store.dispatch("updateLetter", letter);
    };

    const startGame = () => {
      // Activate the game
      store.dispatch("updateGame", true);
      // Navigate to play
      router.push({ name: "Play" });
    };

    return {
      timerConfig,
      timerError,
      handleTimerUpdate,
      letters,
      activeLetters,
      handleLetterUpdate,
      startGame,
    };
  },
};
</script>
